import React, { useState, useCallback, useMemo } from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { EntityType, ActivityDetail, UserPreference } from 'api'
import { ActivityMonitorContainer } from './activityMonitorStyles'
import { ActivityMonitorToolbar } from './ActivityMonitorToolbar'
import { ActivityList } from './ActivityList'
import { WindowActions } from 'epics/windowEpic'
import { createAllActivityDetailsSelector } from 'selectors/activityMonitorSelectors'
import { createUserPreferenceSelector } from 'selectors/userPreferenceSelectors'
import { adminClearingAlertSelector } from 'selectors/dealSelectors'

export interface ActivityMonitorOpenFinProps {
  allActivityDetails: ActivityDetail[]
  showAdminClearingAlert: boolean
  userPreference: UserPreference
  onOpenTicket: (entityId: string, entityType: EntityType, windowTitle: string, ownOrder: boolean) => unknown
}

export const mapStateToProps = createStructuredSelector({
  allActivityDetails: createAllActivityDetailsSelector(),
  showAdminClearingAlert: adminClearingAlertSelector,
  userPreference: createUserPreferenceSelector()
})

export const mapDispatchToProps = {
  onOpenTicket: WindowActions.openTicketWindow
}

export const ActivityMonitorOpenFinComponent: React.FunctionComponent<ActivityMonitorOpenFinProps> = props => {
  const [sortByTimeLeft, setSortByTimeLeft] = useState(false)
  const { allActivityDetails, showAdminClearingAlert, userPreference, onOpenTicket } = props

  const empty = useMemo(() => allActivityDetails.length === 0, [allActivityDetails])

  const handleToggleTimer = useCallback(() => {
    setSortByTimeLeft(prevSortByTimeLeft => !prevSortByTimeLeft)
  }, [])

  const handleActivityClick = useCallback(
    (negotiationId: string, ownOrder: boolean, rfqTitle: string) => {
      onOpenTicket(negotiationId, EntityType.NEGOTIATION, rfqTitle, ownOrder)
    },
    [onOpenTicket]
  )

  return (
    <ActivityMonitorContainer height="calc(100% - 30px)">
      <ActivityMonitorToolbar sortByTimeLeft={sortByTimeLeft} disabled={empty} onToggleTimer={handleToggleTimer} />
      <ActivityList
        allActivityDetails={allActivityDetails}
        showAdminClearingAlert={showAdminClearingAlert}
        userPreference={userPreference}
        sortByTimeLeft={sortByTimeLeft}
        onActivityClick={handleActivityClick}
      />
    </ActivityMonitorContainer>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(ActivityMonitorOpenFinComponent)
